// Coach roster used by the "Meet your coaches" section on /pricing.
// Bios are intentionally tight (1–2 sentences) to keep the section small.
// Full bios live in `Coaches Bios.md` at the project root.

export interface Coach {
  id: string;
  name: string;
  /** Single-line credential / role shown under the name. */
  title: string;
  /** 1–2 sentence bio. Keep tight — this sits inside a small card. */
  bio: string;
  /** Star rating, e.g. 5.0 or 4.97. Null if not yet published. */
  rating: number | null;
  /** Display string, e.g. "1,000+" or "333". Null if not yet published. */
  clientsServed: string | null;
  /** Image URL — a path under /public OR an absolute URL (e.g. the S3 bucket). */
  imageSrc: string;
}

export const COACHES: Coach[] = [
  {
    id: 'julie-macwilliams',
    name: 'Julie MacWilliams',
    title: 'Career Coach',
    bio: '15+ years guiding professionals through career change. Specializes in resume rewrites, mock interviews, and LinkedIn optimization across sales, marketing, finance, and ops.',
    rating: 5.0,
    clientsServed: '1,000+',
    imageSrc: '/coaches/julie-macwilliams.png',
  },
  {
    id: 'linda-lutz',
    name: 'Linda Lutz',
    title: 'Career Coach',
    bio: '',
    rating: 4.95,
    clientsServed: '1,000+',
    imageSrc: '/coaches/linda-lutz.webp',
  },
  {
    id: 'sasha-green',
    name: 'Sasha Green',
    title: 'Mindset & Career Coach',
    bio: 'MBA in Entrepreneurship with 15+ years across career development and business coaching. Specializes in mindset work and building sustainable leadership habits.',
    rating: 4.9,
    clientsServed: '333',
    imageSrc: '/coaches/sasha-green.webp',
  },
  {
    id: 'jennifer-forchelli',
    name: 'Jennifer Forchelli',
    title: 'Career Coach',
    bio: 'Career coach focused on professional reinvention — helping clients turn their strengths into a clear, confident next move.',
    rating: 4.9,
    clientsServed: '600+',
    imageSrc: 'https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_JFo_Jobtestorg.webp',
  },
  {
    id: 'erin-howard',
    name: 'Erin Howard',
    title: 'Career Coach',
    bio: 'Specializes in UX/UI and design careers — portfolio reviews, interview prep, and breaking into product teams.',
    rating: 4.8,
    clientsServed: '713',
    imageSrc: 'https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Erin_Jobtestorg.webp',
  },
  {
    id: 'shannon-ring',
    name: 'Shannon Ring',
    title: 'Career Coach',
    bio: 'Guides mid-career professionals through transitions with résumé strategy, interview prep, and confident salary negotiation.',
    rating: 4.7,
    clientsServed: '400+',
    imageSrc: 'https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Shannon_Jobtestorg.webp',
  },
  {
    id: 'candace-barr',
    name: 'Candace Barr',
    title: 'Career Coach',
    bio: '12+ years guiding professionals through corporate career growth and pivots — from résumé to offer negotiation.',
    rating: 4.9,
    clientsServed: '450',
    imageSrc: 'https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/photos/Coach_Candace_Jobtestorg.png',
  },
  {
    id: 'christen-frank',
    name: 'Christen Frank',
    title: 'Career & Mindset Coach',
    bio: 'ICF-credentialed (ACC) coach who inspires clients to pursue their goals with purpose and confidence — certified in mindset, cognitive-behavioral, and goal-success coaching.',
    rating: 4.85,
    clientsServed: '500+',
    imageSrc: 'https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Christen_Jobtestorg.webp',
  },
];
